export enum EAuthUrls {
  AUTH = 'auth',
  SIGNUP = 'signup',
  FORGOT_PASSWORD = 'forgot-password',
  TEMPORARY_PASSWORD = 'temporary-password',
  LOGIN = 'login',
}
